import { render } from "./Preloader.vue?vue&type=template&id=f46dafe4"
const script = {}

import "./Preloader.vue?vue&type=style&index=0&id=f46dafe4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__